
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { PrescriptionAction, PrescriptionMutation, PrescriptionState } from '@/store/Prescription/PrescriptionRoot';

// Utils
import { snakeCase } from 'lodash';

// Interfaces
import IncludeCall from '@/ship/Models/IncludeCall';
import Pagination from '@/ship/Models/Pagination';

// Components
import CallLogList from '@/components/Prescription/CallLogList.vue';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';

@Component({
    components: {
        CallLogList,
    },
})
export default class PrescriptionListPage extends Vue {
    @PrescriptionAction GET_ALL_CALLS!: (param: { page: number; query: string }) => Promise<IncludeCall[]>;
    @PrescriptionState calls!: IncludeCall[];
    @PrescriptionState pagination!: Pagination;
    @PrescriptionMutation RESET_CALLS!: () => void;
    @Ref() refScroll!: HTMLDivElement;
    @Ref() refSecondaryPage!: HTMLDivElement;

    isSecondaryPageOpen: boolean = false;
    isCreateCall: boolean = true;
    isFirstTime: boolean = false;
    selectorKey: number = 0;
    page: number = 1;
    isRequestReady: boolean = true;

    mounted() {
        this.routeType();
        window.addEventListener('wheel', this.selectWheel);
        window.addEventListener('pointerover', this.checkDevice);
    }

    beforeDestroy() {
        window.removeEventListener('wheel', this.selectWheel);
        window.removeEventListener('pointerover', this.checkDevice);
    }

    checkDevice(e: PointerEvent) {
        if (e.pointerType === 'touch') {
            this.selectWheel();
        }
    }

    /**
     * Проверка на то, сколько px осталось до конца списка
     * При достижении данного параметра произвести запрос на получение предписаний
     * Проверку осуществлять после 200 мс
     */
    selectWheel() {
        setTimeout(() => {
            const { scrollTop, scrollHeight } = this.refScroll;
            const { clientHeight } = document.documentElement;

            if (scrollTop + clientHeight >= scrollHeight - 10 && this.isRequestReady && this.pagination) {
                if (this.pagination.currentPage <= this.pagination.totalPages) {
                    this.isRequestReady = false;
                    this.urlParser().then(() => {
                        this.isRequestReady = true;
                    });
                }
            }
        }, 200);
    }

    /**
     * Convert query url from ?firstParam=param1&secondParam=param2
     * to first_param:param1;second_param:param2
     *
     * API call to load all calls
     */
    async urlParser() {
        const query = Object.entries(this.$route.query).reduce((search, [key, value]) => {
            const isKeyAllowed =
                /(deadline|search|status|createdAt|responsibleId|cityId|projectId|authorId|generalContractorId|subcontractorId|executorId)/g.test(
                    key,
                );
            if (!isKeyAllowed) return search;

            key = key.includes('.') ? key : snakeCase(key);
            return search + `${key}:${value};`;
        }, '');

        const page = this.pagination ? this.pagination.currentPage + 1 : 1;

        await this.GET_ALL_CALLS({ page, query });
    }

    @Watch('$route', { deep: true })
    async routeType() {
        if (this.$route.name === 'calllog.view') {
            this.changeToDisplayViolation();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'calllog.create') {
            this.changeToCreateViolation();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'prescription.calllog') {
            this.isSecondaryPageOpen = false;
            if (!Object.keys(this.$route.query).length) {
                this.RESET_CALLS();
            }
        }

        if (!this.calls) await this.urlParser();

        if (
            !this.calls?.length &&
            (this.$route.name === 'prescription.calllog' || this.$route.name === 'calllog.view')
        ) {
            this.$modal.show(ModalEnum.Alert, {
                title: 'По выбранным критериям заявок на вызов не найдено. Попробуйте применить другие фильтры.',
                actionLabel: this.$t('page.modal.answer.understand'),
            });
        }
    }

    reloadSelectorForm() {
        this.selectorKey++;
    }

    changeToDisplayViolation() {
        this.isCreateCall = false;
    }

    changeToCreateViolation() {
        this.isCreateCall = true;
    }

    openSecondaryPage() {
        this.isSecondaryPageOpen = true;
    }

    closeSecondaryPage() {
        this.isSecondaryPageOpen = false;
    }

    updatePrescriptions() {
        this.RESET_CALLS();
        this.urlParser();
    }
}
